// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import ProgressBar from "containers/Landing/containers/Register/components/ProgressBar/ProgressBar";
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import StepLabel from "../../Register/components/StepLabel";

// ** Utils & Helpers
import formatMessage from "utils/formatMessage";

const Step2 = ({ currentStep, emailRecover, isModal = false }) => {
	const { t } = useTranslation("pages", "landing");

	// ** A/B Tests
	const authModalVersion = useSelector(
		(state) => state.globalCommon.authModal.version
	);

	// #####################################################

	return (
		<Block>
			<StepLabel
				label={t("landing:recover.stepDescriptions.header")}
				isModal={isModal}
				authModalVersion={authModalVersion}
			/>
			<Block mt={3} textCenter>
				<Text
					color={
						isModal && authModalVersion === "darkAndLight"
							? "black"
							: "whiteAlways"
					}
				>
					{formatMessage(
						t(`landing:recover.stepDescriptions.${currentStep}`),
						{
							adresEmail: (
								<Text
									bold
									key="landing:recover.stepDescriptions.secondAdressMobile`"
								>
									{emailRecover}
								</Text>
							),
						}
					)}
				</Text>
			</Block>

			{/* Pasek Postępu */}
			<ProgressBar currentStep={2} totalSteps={4} />
		</Block>
	);
};

// #####################################################

export default Step2;

// #####################################################
